import { render } from "./footer-linklist.vue?vue&type=template&id=34a131b8"
import script from "./footer-linklist.vue?vue&type=script&lang=js"
export * from "./footer-linklist.vue?vue&type=script&lang=js"

import "./footer-linklist.vue?vue&type=style&index=0&id=34a131b8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__